import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {PCSKOperationProps} from "../AccessRequestObjectPage";
import {TOAST_MESSAGE} from "../../../constants/toastMessages";
import {
    approveOperationRequest,
    rejectOperationRequest
} from "../../../services/requestReviews";

const PCSKOperations = (props: PCSKOperationProps) => {
    const navigate = useNavigate();

    function approveOpRequests() {
        props.setIsPageLoading(true);
        approveOperationRequest(props.operationId || "").then((response) => {
            props.setToast({
                isVisible: true,
                message: {
                    details: TOAST_MESSAGE.OPERATION_REQUEST_APPROVAL_DETAIL,
                    heading: TOAST_MESSAGE.OPERATION_REQUEST,
                },
                variant: "success"
            });
            props.setIsPageLoading(false);
            navigate("/");
        }).catch((err: any) => {
            // Try to extract a backend error message
            let backendMessage = err?.response?.data?.message || err?.message || TOAST_MESSAGE.OPERATION_REQUEST_APPROVAL_ERROR;
            props.setToast({
                isVisible: true,
                message: {
                    details: backendMessage,
                    heading: TOAST_MESSAGE.ERROR,
                },
                variant: "error"
            });
            props.setIsPageLoading(false);
            navigate("/");
        })
    }

    function rejectOpRequests() {
        props.setIsPageLoading(true);
        rejectOperationRequest(props.operationId || "").then((response) => {
            props.setToast({
                isVisible: true,
                message: {
                    details: TOAST_MESSAGE.OPERATION_REQUEST_REJECT_DETAIL,
                    heading: TOAST_MESSAGE.OPERATION_REQUEST,
                },
                variant: "success"
            });
            props.setIsPageLoading(false);
            navigate("/");
        }).catch((err) => {
            let backendMessage = err?.response?.data?.message || err?.message || TOAST_MESSAGE.OPERATION_REQUEST_REJECT_ERROR;
            props.setToast({
                isVisible: true,
                message: {
                    details: backendMessage,
                    heading: TOAST_MESSAGE.ERROR,
                },
                variant: "error"
            });
            props.setIsPageLoading(false);
            navigate("/");
        })
    }

    useEffect(() => {
        const fetchData = async () => {
            if (props.requestType === "operation-approve") {
                approveOpRequests();
            }
            if (props.requestType === "operation-reject") {
                rejectOpRequests();
            }
        };
        fetchData();
    }, [props.operationId, props.requestType]);

};

export default PCSKOperations;
